import { memo } from 'react'

const FCBarChart = () => null // ! TODO

export const BarChart = memo(FCBarChart)
